import { createAction } from '@reduxjs/toolkit';

import type { AUDIO_ENHANCEMENT_TOGGLE_STATUS } from 'js/src/data/audio-enhancement/audio-enhancement-types';
import { AUDIO_ENHANCEMENT_ACTIONS } from 'js/src/data/audio-enhancement/audio-enhancement-types';

export const setAudioEnhancementStatusForSceneGroup = createAction<{
    sceneGroupId: string;
    status: AUDIO_ENHANCEMENT_TOGGLE_STATUS;
}>(AUDIO_ENHANCEMENT_ACTIONS.SET_AUDIO_ENHANCEMENT_TOGGLE);

export const setAudioEnhancementLoadingForSceneGroup = createAction<{
    sceneGroupId: string;
    isLoading: boolean;
    abortController?: AbortController;
}>(AUDIO_ENHANCEMENT_ACTIONS.SET_AUDIO_ENHANCEMENT_LOADING);
